const APIHOST = import.meta.env.VITE_APIHOST || 'https://api.pushback.io';
const WEBHOST = import.meta.env.VITE_WEBHOST || 'https://web.pushback.io';
const STRIPEKEY = import.meta.env.VITE_STRIPEKEY || '';
const PRODUCT = import.meta.env.VITE_PRODUCT || '';
export { WEBHOST, STRIPEKEY, PRODUCT };

export default APIHOST;
